import React from "react";
import { Link } from "react-router-dom";
import styled from 'styled-components'

const LinkTo = styled(Link)`
font-size: 20px;
font-family: "aktiv-grotesk", sans-serif;
/* font-family: 'Heebo', sans-serif; */
/* font-family: 'Nuosu SIL', serif; */
/* text-transform: uppercase; */
/* font-style: italic; */
text-decoration: none;
color: black;
padding: 10px;


&:hover {
  background-color: yellow;
  font-style: italic;
}

&:visited {
  color: black;
}

@media (min-width: 375px) and (max-width: 912px) {
      font-size: 10px;
    }
`

const AboutBox = styled.div`
padding: 40px;

@media (min-width: 375px) and (max-width: 912px) {
      padding: 10px;
    }
`
const AboutMeText = styled.p`
font-size: 25px;
padding: 50px;
font-family: "aktiv-grotesk", sans-serif;
line-height: 25px;

@media (min-width: 375px) and (max-width: 912px) {
      font-size: 16px;
      padding: 10px;
    }
`
const LinkBox = styled.div`
padding: 10px;
text-align: center;
display: flex;
justify-content: space-evenly;

`

const LinkPortfolio = styled.a`
font-size: 20px;
font-family: "aktiv-grotesk", sans-serif;
/* font-family: 'Heebo', sans-serif; */
/* font-family: 'Nuosu SIL', serif; */
/* text-transform: uppercase; */
/* font-style: italic; */
text-decoration: none;
color: black;
padding: 10px;


&:hover {
  background-color: yellow;
  font-style: italic;
}

&:visited {
  color: black;
}

@media (min-width: 375px) and (max-width: 912px) {
      font-size: 10px;
    }
`

const AboutMe = () => {
  return (
    <AboutBox>
      <AboutMeText>I'm Emma. A front end developer with years of experience in digital photo
      editing and a bit of knowledge in graphic design. In this project I've
      taken care of some old photographic negatives that I found in a second
      hand shop in old town, Stockholm. I have scanned them and restored them.
      Some are colorised with colors I had to make up myself as I don't know who
      the people in the images are. This site is made to hopefully gain some
      information about it though. Please help.
      </AboutMeText>
      <LinkBox>
      <LinkTo to="/contactme">Let me know if you know something</LinkTo>
      <LinkPortfolio href="https://emmasprings-portfolio.netlify.app/" target="_blank" rel="noopener noreferrer">Other projects</LinkPortfolio>
      <LinkPortfolio href="https://emmas.netlify.app/" target="_blank" rel="noopener noreferrer">More</LinkPortfolio>
      </LinkBox>
    </AboutBox>
  );
};

export default AboutMe;
